import { render, staticRenderFns } from "./send-indications-icon2.vue?vue&type=template&id=5a3afdfb&scoped=true"
import script from "./send-indications-icon2.vue?vue&type=script&lang=js"
export * from "./send-indications-icon2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3afdfb",
  null
  
)

export default component.exports